import { render, staticRenderFns } from "./ModalCustomerList.vue?vue&type=template&id=2eba7b38&scoped=true"
import script from "./ModalCustomerList.vue?vue&type=script&lang=js"
export * from "./ModalCustomerList.vue?vue&type=script&lang=js"
import style0 from "./ModalCustomerList.vue?vue&type=style&index=0&id=2eba7b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eba7b38",
  null
  
)

export default component.exports